var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "px-0", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-programa", {
                attrs: { programa: _vm.solicitud?.programa },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-overlay",
                { attrs: { show: _vm.consultando } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-tabs",
                            {
                              attrs: {
                                pills: "",
                                card: "",
                                vertical: "",
                                "active-nav-item-class":
                                  "font-weight-bold bg-light text-primary",
                                "content-class": "mt-3",
                              },
                              model: {
                                value: _vm.tabIdx,
                                callback: function ($$v) {
                                  _vm.tabIdx = $$v
                                },
                                expression: "tabIdx",
                              },
                            },
                            [
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "apeironGwApp.planDeEstudiosSnp.tabs.planDeEstudiosTab"
                                    ),
                                    active: "",
                                  },
                                },
                                [
                                  _c(
                                    "b-card-text",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c(
                                              "h4",
                                              { staticClass: "text-center" },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.$t(
                                                        "apeironGwApp.planDeEstudiosSnp.tabs.planDeEstudiosTitulo"
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "my-2" },
                                        [
                                          _c("b-col", [
                                            _c("hr", {
                                              staticClass:
                                                "linea-horizontal-roja",
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.periodoLectivo"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .periodoLectivo
                                                        ?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-periodo-lectivo",
                                                  },
                                                },
                                                [
                                                  _c("b-form-select", {
                                                    staticClass:
                                                      "resaltar-opciones-disabled",
                                                    attrs: {
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      name: "input-periodo-lectivo",
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .periodoLectivo
                                                          ?.$invalid,
                                                      options:
                                                        _vm.periodosLectivos,
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "first",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "b-form-select-option",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    undefined,
                                                                  disabled: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .$t(
                                                                        "apeironGwApp.planDeEstudiosSnp.form.seleccionarUno"
                                                                      )
                                                                      .toString()
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ]),
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .periodoLectivo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "periodoLectivo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.periodoLectivo",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .periodoLectivo
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.periodoNuevoIngreso"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .periodicidad?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-periodo-nuevo-ingreso",
                                                  },
                                                },
                                                [
                                                  _c("b-form-select", {
                                                    staticClass:
                                                      "resaltar-opciones-disabled",
                                                    attrs: {
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      name: "input-periodo-nuevo-inrgeso",
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .periodicidad
                                                          ?.$invalid,
                                                      options:
                                                        _vm.periodosNuevoIngreso,
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "first",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "b-form-select-option",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    undefined,
                                                                  disabled: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .$t(
                                                                        "apeironGwApp.planDeEstudiosSnp.form.seleccionarUno"
                                                                      )
                                                                      .toString()
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ]),
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .periodicidad,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "periodicidad",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.periodicidad",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .periodicidad
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.duracionOficial"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .duracionOficial
                                                        ?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-duracion-oficial",
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      type: "number",
                                                      name: "input-duracion-oficial",
                                                      id: "input-duracion-oficial",
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .duracionOficial
                                                          ?.$invalid,
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      min: 0,
                                                      max: 60,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .duracionOficial,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "duracionOficial",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.duracionOficial",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .duracionOficial
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .duracionOficial
                                                            ?.$minValue,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.min",
                                                              { min: 0 }
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .duracionOficial
                                                            ?.$maxValue,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.max",
                                                              { max: 60 }
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.totalPeriodosLectivos"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .totalPeriodosLectivos
                                                        ?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-total-periodos-lectivos",
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      type: "number",
                                                      name: "input-total-periodos-lectivos",
                                                      id: "input-total-periodos-lectivos",
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .totalPeriodosLectivos
                                                          ?.$invalid,
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      min: 0,
                                                      max: 20,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .totalPeriodosLectivos,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "totalPeriodosLectivos",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.totalPeriodosLectivos",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .totalPeriodosLectivos
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .totalPeriodosLectivos
                                                            ?.$minValue,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.min",
                                                              { min: 0 }
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .totalPeriodosLectivos
                                                            ?.$maxValue,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.max",
                                                              { max: 20 }
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", md: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.porcentajePracticas"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .porcentajePracticas
                                                        ?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-porcentaje-practicas",
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      type: "number",
                                                      name: "input-porcentaje-practicas",
                                                      id: "input-porcentaje-practicas",
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .porcentajePracticas
                                                          ?.$invalid,
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      min: 0,
                                                      max: 100,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .porcentajePracticas,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "porcentajePracticas",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.porcentajePracticas",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .porcentajePracticas
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .porcentajePracticas
                                                            ?.$minValue,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.min",
                                                              { min: 0 }
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .porcentajePracticas
                                                            ?.$maxValue,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.max",
                                                              { max: 100 }
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.actividades"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .actividades?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-actividades",
                                                  },
                                                },
                                                [
                                                  _c("b-form-textarea", {
                                                    attrs: {
                                                      id: "input-actividades",
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .actividades
                                                          ?.$invalid,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .actividades,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "actividades",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.actividades",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .actividades
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "apeironGwApp.planDeEstudiosSnp.tabs.modificacionesTab"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "b-card-text",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c(
                                              "h4",
                                              { staticClass: "text-center" },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.$t(
                                                        "apeironGwApp.planDeEstudiosSnp.tabs.modificacionesTitulo"
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "my-2" },
                                        [
                                          _c("b-col", [
                                            _c("hr", {
                                              staticClass:
                                                "linea-horizontal-roja",
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.modificaciones"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .modificacion?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-modificaciones",
                                                  },
                                                },
                                                [
                                                  _c("b-form-textarea", {
                                                    attrs: {
                                                      id: "input-modificaciones",
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .modificacion
                                                          ?.$invalid,
                                                      rows: "6",
                                                      "max-rows": "10",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .modificacion,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "modificacion",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.modificacion",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .modificacion
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _vm.esEscritura
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            !!_vm.planDeEstudios
                                                              .fechaActualizacion,
                                                          expression:
                                                            "!!planDeEstudios.fechaActualizacion",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "accion-label",
                                                      attrs: {
                                                        pill: "",
                                                        variant: "light",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.reiniciaCampoFechaActualizacion()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "apeironGwApp.planDeEstudiosSnp.acciones.reset"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.fechaActualizacion"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .fechaActualizacion
                                                        ?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-fecha-actualizacion",
                                                  },
                                                },
                                                [
                                                  _c("b-form-datepicker", {
                                                    attrs: {
                                                      name: "input-fecha-actualizacion",
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .fechaActualizacion
                                                          ?.$invalid,
                                                      placeholder: _vm.$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.fechaActualizacion"
                                                      ),
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      max: new Date(),
                                                      locale: "es",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .fechaActualizacion,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "fechaActualizacion",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.fechaActualizacion",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .fechaActualizacion
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "apeironGwApp.planDeEstudiosSnp.tabs.objetivosTab"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "b-card-text",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c(
                                              "h4",
                                              { staticClass: "text-center" },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.$t(
                                                        "apeironGwApp.planDeEstudiosSnp.tabs.objetivosTitulo"
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "my-2" },
                                        [
                                          _c("b-col", [
                                            _c("hr", {
                                              staticClass:
                                                "linea-horizontal-roja",
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.objetivo"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .objetivo?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-objetivo",
                                                  },
                                                },
                                                [
                                                  _c("b-form-textarea", {
                                                    attrs: {
                                                      id: "input-objetivo",
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .objetivo?.$invalid,
                                                      rows: "6",
                                                      "max-rows": "10",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .objetivo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "objetivo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.objetivo",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .objetivo?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "apeironGwApp.planDeEstudiosSnp.tabs.congruenciaTab"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "b-card-text",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c(
                                              "h4",
                                              { staticClass: "text-center" },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.$t(
                                                        "apeironGwApp.planDeEstudiosSnp.tabs.congruenciaTitulo"
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "my-2" },
                                        [
                                          _c("b-col", [
                                            _c("hr", {
                                              staticClass:
                                                "linea-horizontal-roja",
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.congruencia"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .congruencia?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    "label-for":
                                                      "input-congruencia",
                                                  },
                                                },
                                                [
                                                  _c("b-form-textarea", {
                                                    attrs: {
                                                      id: "input-congruencia",
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .congruencia
                                                          ?.$invalid,
                                                      rows: "6",
                                                      "max-rows": "10",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .congruencia,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "congruencia",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.congruencia",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .congruencia
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "apeironGwApp.planDeEstudiosSnp.tabs.perfilIngresoTab"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "b-card-text",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c(
                                              "h4",
                                              { staticClass: "text-center" },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.$t(
                                                        "apeironGwApp.planDeEstudiosSnp.tabs.perfilIngresoTitulo"
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "my-2" },
                                        [
                                          _c("b-col", [
                                            _c("hr", {
                                              staticClass:
                                                "linea-horizontal-roja",
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.perfilIngreso"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .perfilIngreso?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    description: _vm.$t(
                                                      "apeironGwApp.planDeEstudiosSnp.form.perfilIngresoDesc"
                                                    ),
                                                    "label-for":
                                                      "input-perfil-ingreso",
                                                  },
                                                },
                                                [
                                                  _c("b-form-textarea", {
                                                    attrs: {
                                                      id: "input-perfil-ingreso",
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .perfilIngreso
                                                          ?.$invalid,
                                                      rows: "6",
                                                      "max-rows": "10",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .perfilIngreso,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "perfilIngreso",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.perfilIngreso",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .perfilIngreso
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "apeironGwApp.planDeEstudiosSnp.tabs.perfilEgresoTab"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "b-card-text",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c(
                                              "h4",
                                              { staticClass: "text-center" },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.$t(
                                                        "apeironGwApp.planDeEstudiosSnp.tabs.perfilEgresoTitulo"
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "my-2" },
                                        [
                                          _c("b-col", [
                                            _c("hr", {
                                              staticClass:
                                                "linea-horizontal-roja",
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    label: `${_vm
                                                      .$t(
                                                        "apeironGwApp.planDeEstudiosSnp.form.perfilEgreso"
                                                      )
                                                      .toString()}${
                                                      _vm.$v.planDeEstudios
                                                        .perfilEgreso?.required
                                                        ? " *"
                                                        : ""
                                                    }`,
                                                    description: _vm.$t(
                                                      "apeironGwApp.planDeEstudiosSnp.form.perfilEgresoDesc"
                                                    ),
                                                    "label-for":
                                                      "input-perfil-egreso",
                                                  },
                                                },
                                                [
                                                  _c("b-form-textarea", {
                                                    attrs: {
                                                      id: "input-perfil-egreso",
                                                      disabled:
                                                        !_vm.esEscritura,
                                                      state:
                                                        !_vm.$v.planDeEstudios
                                                          .perfilEgreso
                                                          ?.$invalid,
                                                      rows: "6",
                                                      "max-rows": "10",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.planDeEstudios
                                                          .perfilEgreso,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.planDeEstudios,
                                                          "perfilEgreso",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "planDeEstudios.perfilEgreso",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state:
                                                          !_vm.$v.planDeEstudios
                                                            .perfilEgreso
                                                            ?.$invalid,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "entity.validation.required"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.anterior()
                                },
                              },
                            },
                            [_vm._v("‹")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.siguiente()
                                },
                              },
                            },
                            [_vm._v("›")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-right" },
                        [
                          _vm.esEscritura
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.guardarSeccion()
                                    },
                                  },
                                },
                                [
                                  _c("b-icon", {
                                    attrs: { icon: "save", variant: "primary" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.planDeEstudiosSnp.acciones.guardar"
                                        )
                                      ),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }